
import {Vue, Component, Prop, Watch} from 'vue-property-decorator';
import {mechanismApi} from "@/api/organization";
import {computed} from "vue";
import {integrityApi} from "@/api/integrity";

@Component({})
export default class Credit extends Vue {
    @Prop()
    private orgId: any;
    private organizations = [];// 企业列表
    private showQuery = false;
    private loading = false;
    private queryParams = {
        name: '',
        area: '',
        status: 1,
        current: 1,
        size: 10,
        total: 0
    }
    complaintList = [] as any;
    superviseList = [] as any;
    punishList = [] as any;

    created(){
      this.loadData();
    }
    @Watch("orgId")
    orgIdChanged() {
      this.loadData();
    }
    loadData(){
        this.showQuery = false;
        this.loading = true;
        const params = {orgId: '', current: -1};
        const userData = this.$store.state.AuthedUser;
        params.orgId = this.orgId ? this.orgId : userData.organizationId;
        Promise.all([
          integrityApi.pageComplaint(params),
          integrityApi.pageSupervise(params),
          integrityApi.pagePunish(params)
        ]).then((arr) => {
            this.loading = false;
            const res1 = arr[0];
            const res2 = arr[1];
            const res3 = arr[2];
            if(res1.data.result === 0){
             this.complaintList = res1.data.data.records;
            }
            if(res2.data.result === 0){
              this.superviseList = res2.data.data.records;
            }
            if(res3.data.result === 0){
              this.punishList = res3.data.data.records;
            }
        }).catch(() => {
          this.loading = false;
        });
    }
    pageSizeChange(val: number) {
        this.queryParams.size = val;
        this.loadData();
    }
    pageCurrentChange(val: number) {
        this.queryParams.current = val;
        this.loadData();
    }
    indexMethod(index: any) {
        return (this.queryParams.current-1)*this.queryParams.size+index+1;
    }
}
